import { IHeaderGroupParams } from '@ag-grid-community/core';
import { ToggleButton } from '@frk/eds-components';
import { CalcTypeConfig } from '@products/fund-listing/services/calc-type.config';
import {
  CalcTypeStd,
  ConfigurationId,
  FundShareClassId,
  ProductData,
  WebProductTaxonomy,
} from '@types';
import { Observable } from 'rxjs';

export enum FundListingType {
  COMBINED = 'COMBINED',
  PERFORMANCE = 'PERFORMANCE',
  IDENTIFIERS = 'IDENTIFIERS',
  YIELDS = 'YIELDS',
  RATINGS = 'RATINGS',
  PRICE = 'PRICE',
  SIMILAR_PRODUCT = 'SIMILAR_PRODUCT',
}

// base controller interface
// At some point, it may make sense to refactor this as an Abstract Class
// the child interfaces would then be refactored as Concrete classes
export interface FundListingController {
  fundListingType: FundListingType;
  componentName: string; // BR Component name used for ordering footnotes
  productType: ConfigurationId;
  productTaxonomy?: WebProductTaxonomy;
  currentPage?: ProductData[];
  hideFavoriteCol?: boolean;
  showRemoveFavoriteCol?: boolean;
  hideNavChangeCol?: boolean;
  hideFactSheetCol?: boolean;
  showLegendIcons?: boolean;
  hasDataMigrated?: boolean;
  isHomeOfficeUser?: boolean;
  // TODO: refactor out PPSS service dependency
  updateFavourite?: (fund: FundShareClassId) => void;
}

export interface FundListingCalcTypeController extends FundListingController {
  setCalcType?: (value: CalcTypeStd | ToggleButton) => void;
  showCalcTypeHeader?: boolean;
  getCalcTypeConfig: () => CalcTypeConfig;
  // TODO: should methods below be optional? Don't seem to be used by Yields
  setGridAPIs: (params: IHeaderGroupParams) => void;
  getCalcType$: () => Observable<CalcTypeStd>;
  getSelectedCalcType: () => CalcTypeStd;
  // returns array that may also contain applicable values eg PUREGROSS
  getSelectedCalcTypes: () => CalcTypeStd[];
}
